export default __webpack_public_path__ + "static/media/video.1c6b32bd.mkv";